const productDataEle = document.querySelectorAll('[data-quiz-product-id]');
let quickProductData = {};
productDataEle.forEach((ele)=>{
  let id = ele.getAttribute('data-quiz-product-id');
  quickProductData[id] = {
    "reviews" : ele.querySelector('[data-quiz-review]').innerHTML
  }
})

document.addEventListener("octane.quiz.completed", async function (event) {
  const quicResultData = event.detail;
  const resultItems = document.querySelectorAll('[data-element="oct-quiz-resultitem"]');

  for (const ele of resultItems) {
    let href = ele.querySelector('[href]').getAttribute('href').split('?')[0].replace(window.location.origin, '');
    let quizAdditionalDataEle = document.querySelector(`[data-quiz-product-url="${href}"]`);

    if (quizAdditionalDataEle) {
      if (ele.closest('.oct-quiz-product-block--horizontal')) {
        let reviewHtml = quizAdditionalDataEle.querySelector('[data-quiz-review]')?.innerHTML;
        if (reviewHtml) {
          let newReviewHtml = document.createElement('div');
          newReviewHtml.classList.add('card-review-content');
          newReviewHtml.innerHTML = reviewHtml;
          ele.querySelector('.oct-quiz-result-item__copy-wrapper').append(newReviewHtml);
        }

        let blog_group_url = quizAdditionalDataEle.getAttribute('data-metaobject-blog-group');
        if (blog_group_url && document.querySelector(`[data-blog-group-url="${blog_group_url}"]`) === null) {
          await fetchHTML(blog_group_url);
        }
      }

      let reviewStarHtml = quizAdditionalDataEle.querySelector('[data-quiz-review-star]')?.innerHTML;
      if (reviewStarHtml) {
        let newReviewStarHtml = document.createElement('div');
        newReviewStarHtml.classList.add('card-review-main');
        newReviewStarHtml.innerHTML = reviewStarHtml;
        ele.querySelector('.oct-quiz-result-item__copy-wrapper').prepend(newReviewStarHtml);
      }
    }
  }
  _removeDuplicateEntries();
});

async function fetchHTML(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.text();
    const tempHtml = document.createElement('div');
    tempHtml.classList.add('quiz-blog-main');
    tempHtml.innerHTML = data;

    const blogContent = tempHtml.querySelector('[data-blog-posts]');
    if (blogContent) {
      tempHtml.innerHTML = blogContent.innerHTML;
      let existingGroupEle = document.querySelector('[data-blog-group-url]')
      if (!existingGroupEle) {
        document.querySelector('.oct-quiz-content').append(tempHtml);
      }else{
        existingGroupEle.querySelector('[data-blog-quiz-cards]').append(tempHtml.querySelector('[data-blog-quiz-cards]'));
      }
      return true;
    } else {
      throw new Error("Blog content not found in fetched HTML.");
    }
  } catch (error) {
    console.error("Error fetching HTML:", error);
    return false;
  }
}

function _removeDuplicateEntries() {
  const allElements = document.querySelectorAll('[id]');
  const seenIds = new Set();

  allElements.forEach((el) => {
      const id = el.id;
      if (seenIds.has(id)) {
          el.remove(); // Remove duplicate
      } else {
          seenIds.add(id); // Mark as seen
      }
  });
}